/* eslint-disable max-len */
import React, { useRef } from 'react';
import AnimatedModel from '../Animation/AnimatedModel';
import AnimatedHeading from '../Animation/AnimatedHeading';
import UpdateButton from '../UpdateButton';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import AnimatedButton from '../Animation/AnimatedButton';

const ConfirmationPrompt = ({
    handleClose, 
    tittle, 
    message, 
    buttonName, 
    handleOnCLickActivate, 
    loadingActivation,
    cancleButton,
    crossMark,
    additionalMessage,
    textPosition,
    dialogueWidth}) => {
    const outsideClickRef = useRef();
    useOnClickOutside(outsideClickRef, () => {
        handleClose();
    });

    const minDialogueWidth = (dialogueWidth === '' || dialogueWidth === undefined) ? 'min-w-[400px]' : 'min-w-['+dialogueWidth+']';
    const maxDialogueWidth = (dialogueWidth === '' || dialogueWidth === undefined) ? 'max-w-[400px]' : 'max-w-['+dialogueWidth+']';
    const defaultTextPosition = (textPosition === '' || textPosition === undefined) ? 'text-center' : textPosition;


    return (
        <AnimatedModel 
            Children={
                <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50" id="modalforDeactivate" tabindex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{display: "block"}}>
                    <div ref={outsideClickRef} data-te-modal-dialog-ref="" className={`pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-1 transition-all duration-300 ease-in-out ${minDialogueWidth} mx-auto ${maxDialogueWidth}`}>
                        <div className="pointer-events-auto flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600 mx-auto relative">
                            {(tittle !== "" && tittle !== undefined) && <div className="flex flex-shrink-0 items-center rounded-t-md bg-blue-50 py-2 px-3">
                                <AnimatedHeading className={`text-lg font-medium text-[#031624] text-center`} Children={tittle} />
                                {/* <!--Close button--> */}
                                <button onClick={() => handleClose()} type="button" className="absolute right-3 box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none" data-te-modal-dismiss="" aria-label="Close">
                                    <img loading="lazy" decoding="async" src="/images/modalClose.svg" alt="icon"/>
                                </button>
                            </div>}
                            <div className={`relative py-4 px-6`}>
                                {(additionalMessage !== "" && additionalMessage !== undefined) && <AnimatedHeading className={`${defaultTextPosition} mb-3`}  Children={additionalMessage} /> }
                                <AnimatedHeading className={`${defaultTextPosition}`} Children={message} />
                            </div>
                            <div className="flex w-fit mx-auto p-3 pt-1">
                                {cancleButton === undefined && <AnimatedButton
                                    handleClick={() => handleClose()} 
                                    className="cancl-btn1" 
                                    buttonName="Cancel"
                                    disabled={loadingActivation}
                                />}
                                <UpdateButton loading={loadingActivation} ButtonName={buttonName} handleOnCLick={handleOnCLickActivate}/>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
        
    );
}

export default ConfirmationPrompt;
